import React from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/utils/merge';
import { ROLE_LABELS, STATUS_LABELS, fmtWhen } from './format';

// The left column: one row per conversation — name, role, last message, time,
// unread count, open/closed. Loads more on scroll to the bottom.
export const ConversationList = ({
	items,
	selectedId,
	onSelect,
	onMore,
	hasMore,
	loading,
	showCity,
}) => (
	<div
		className='flex min-h-0 flex-1 flex-col overflow-y-auto'
		onScroll={e => {
			const el = e.currentTarget;
			if (hasMore && !loading && el.scrollTop + el.clientHeight > el.scrollHeight - 80) onMore?.();
		}}
	>
		{items.map(c => (
			<button
				key={c.id}
				type='button'
				onClick={() => onSelect(c.id)}
				className={cn(
					'flex w-full items-start gap-3 border-b border-slate-100 px-3 py-2.5 text-left hover:bg-slate-50',
					selectedId === c.id && 'bg-teal-50 hover:bg-teal-50',
				)}
			>
				<div
					className={cn(
						'flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-[14px] font-semibold text-white',
						c.type === 'order'
							? 'bg-amber-500'
							: { shop: 'bg-sky-500', delivery: 'bg-emerald-500', admin: 'bg-[#0f9b9d]' }[
									c.counterpartRole
								] || 'bg-slate-400',
					)}
				>
					{c.type === 'order' ? (
						<Package size={18} />
					) : (
						(c.title || '?').trim().charAt(0).toUpperCase()
					)}
				</div>
				<div className='flex min-w-0 flex-1 flex-col'>
					<div className='flex items-center gap-2'>
						<span
							className={cn(
								'truncate text-[14px]',
								c.unread ? 'font-bold text-slate-900' : 'font-semibold text-slate-800',
							)}
						>
							{c.title}
						</span>
						<span className='ml-auto shrink-0 text-[11px] text-slate-400'>
							{fmtWhen(c.lastMessage?.at || c.updatedAt)}
						</span>
					</div>
					<div className='flex items-center gap-1.5 text-[11px] text-slate-500'>
						<span>{ROLE_LABELS[c.counterpartRole] || c.counterpartRoleLabel}</span>
						{showCity && c.cityName && <span>· {c.cityName}</span>}
						{c.status !== 'open' && (
							<span className='rounded bg-slate-200 px-1 text-slate-600'>
								{STATUS_LABELS[c.status]}
							</span>
						)}
					</div>
					<div className='flex items-center gap-2'>
						<span
							className={cn('truncate text-[13px]', c.unread ? 'text-slate-800' : 'text-slate-500')}
						>
							{c.lastMessage
								? `${c.lastMessage.senderName ? `${c.lastMessage.senderName}: ` : ''}${c.lastMessage.body || '—'}`
								: 'Χωρίς μηνύματα'}
						</span>
						{!!c.unread && (
							<span className='ml-auto shrink-0 rounded-full bg-[#0f9b9d] px-1.5 text-[11px] font-semibold text-white'>
								{c.unread}
							</span>
						)}
					</div>
				</div>
			</button>
		))}
		{loading && <div className='p-3 text-center text-[13px] text-slate-400'>Φόρτωση…</div>}
		{!loading && !items.length && (
			<div className='p-6 text-center text-[13px] text-slate-400'>Δεν υπάρχουν συνομιλίες.</div>
		)}
	</div>
);
